import * as React from "react";
import {
    MessageBar,
    MessageBarBody,
    MessageBarActions,
    Button
} from "@fluentui/react-components";
import { DismissRegular } from "@fluentui/react-icons";

interface ICartNotificationProps {
    onDismiss: () => void;
    message: string;
}

const CartNotification: React.FC<ICartNotificationProps> = (props) => {
    return (
        <MessageBar intent={"error"}>
            <MessageBarBody>
                {props.message}
            </MessageBarBody>
            <MessageBarActions
                containerAction={
                    <Button
                        aria-label="dismiss"
                        appearance="transparent"
                        icon={<DismissRegular />}
                        onClick={props.onDismiss}
                    />
                }
            >
            </MessageBarActions>
        </MessageBar>
    );
}
export default CartNotification;